(() => {
  function initialize(root) {
    root.querySelectorAll('[data-wooden-urn]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const select = section.querySelector('[data-product-variant]');
      const fields = section.querySelector('[data-urn-personalization]');
      const name = section.querySelector('[data-urn-name]');
      const compare = section.querySelector('[data-urn-compare]');
      const image = section.querySelector('[data-product-media] img');
      const updateImage = (url, alt) => {
        if (!image || !url) return;
        image.removeAttribute('srcset');
        image.src = url;
        image.alt = alt || '';
        section.querySelectorAll('[data-gallery-image]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.galleryImage === url));
        });
        const selected = section.querySelector('[data-gallery-image][aria-pressed="true"]');
        const strip = selected?.parentElement;
        if (strip) {
          const itemBox = selected.getBoundingClientRect();
          const stripBox = strip.getBoundingClientRect();
          if (itemBox.left < stripBox.left || itemBox.right > stripBox.right) {
            strip.scrollLeft += itemBox.left - stripBox.left - (strip.clientWidth - selected.offsetWidth) / 2;
          }
        }
      };
      const validateName = () => name.setCustomValidity(name.required && !name.value.trim() ? name.dataset.invalid : '');
      const update = () => {
        const option = select.selectedOptions[0];
        const printing = option.dataset.urnPrint === 'true';
        fields.hidden = !printing;
        fields.disabled = !printing;
        name.required = printing;
        validateName();
        compare.hidden = !option.dataset.urnCompare;
        compare.textContent = option.dataset.urnCompare;
        updateImage(option.dataset.urnImage, option.dataset.urnAlt);
      };
      select.addEventListener('change', update);
      name.addEventListener('input', validateName);
      section.addEventListener('click', event => {
        const button = event.target.closest('[data-gallery-image]');
        if (button) updateImage(button.dataset.galleryImage, button.dataset.urnImageAlt);
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
